import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../window.factory';

@Injectable({ providedIn: 'root' })
export class Sidebar2Service {
  constructor(@Inject(WINDOW) private window: Window) {}

  emailSupport(PIN: number): void {
    this.openExternalUrl(
      `mailto:support@getapollo.io?subject=&body=%0D%0A%0D%0A%0D%0APIN: ${PIN}`,
    );
  }

  generateLink(path: string[], params: any = {}): string[] {
    Object.keys(params).forEach((k) => {
      if (typeof params[k] === 'object') {
        params[k] = JSON.stringify(params[k]);
      }
    });

    return [...path, params];
  }

  injectLocale(locale: string, string: string): string {
    if (!string || typeof string !== 'string') return;
    return string.replace(/{locale}/g, locale);
  }

  openExternalUrl(url: string): void {
    const link = this.window.open(url, '_blank');
  }

  openChat(): void {
    if (this.window.Intercom) {
      this.window.Intercom('showNewMessage');
    }
  }

  scheduleCall(locale: string): void {
    this.openChat();

    // if (this.window.Intercom) {
    //   this.window.Intercom('showMessages');
    // }
  }
}
